"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var Tab_1 = __importDefault(require("./Tab"));
var styles_1 = require("./styles");
var Tabs = function (_a) {
    var tabs = _a.tabs, byState = _a.byState, headerOnly = _a.headerOnly, scrollable = _a.scrollable;
    var _b = (0, react_1.useState)(0), activeTabIndex = _b[0], setActiveTabIndex = _b[1];
    var activeTab = tabs[activeTabIndex];
    var onTabChangeHandler = function (index) {
        setActiveTabIndex(index);
    };
    if (!byState) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TabsWrapper, { children: [(0, jsx_runtime_1.jsx)(styles_1.TabsContainer, __assign({ role: "tablist", "aria-label": "Navigation tabs", scrollable: scrollable }, { children: tabs.map(function (tab, index) {
                                var _a;
                                return ((0, jsx_runtime_1.jsx)(Tab_1.default, { tab: tab }, (_a = tab.path) !== null && _a !== void 0 ? _a : index.toString()));
                            }) })), (0, jsx_runtime_1.jsx)(styles_1.TabsLine, {})] }), !headerOnly && ((0, jsx_runtime_1.jsx)(react_router_dom_1.Routes, { children: tabs.map(function (tab, index) {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: tab.path, element: tab.element, Component: tab.Component }, (_a = tab.path) !== null && _a !== void 0 ? _a : index.toString()));
                    }) }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TabsWrapper, { children: [(0, jsx_runtime_1.jsx)(styles_1.TabsContainer, __assign({ role: "tablist", "aria-label": "Navigation tabs", scrollable: scrollable }, { children: tabs.map(function (tab, index) {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)(Tab_1.default, { tabIndex: tab.index, activeTabIndex: activeTabIndex, tab: tab, onTabChangeHandler: onTabChangeHandler }, (_a = tab.index) !== null && _a !== void 0 ? _a : index.toString()));
                        }) })), (0, jsx_runtime_1.jsx)(styles_1.TabsLine, {})] }), (activeTab === null || activeTab === void 0 ? void 0 : activeTab.element) && ((0, jsx_runtime_1.jsx)("div", __assign({ role: "tabpanel" }, { children: activeTab.element }), activeTab.index)), (activeTab === null || activeTab === void 0 ? void 0 : activeTab.Component) && (0, jsx_runtime_1.jsx)(activeTab.Component, {}, activeTab.index)] }));
};
exports.default = Tabs;
